module.exports = __webpack_public_path__ + "static/article-image-04-23f4bd3835738cb48294e44f6055cb24.jpg";